import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const syncWaitRoute: InvariantJiraRoute = {
	name: 'sync-wait',
	path: '/jira/sync-wait',
	exact: true,
};
